"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.PLAYER_STATES = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));

var _UserService = _interopRequireDefault(require("./services/UserService"));

var _GameService = _interopRequireDefault(require("./services/GameService"));

var _RestService = _interopRequireDefault(require("./services/RestService"));

var _NavigationManager = _interopRequireDefault(require("../../NavigationManager"));

var _QuizHome = _interopRequireDefault(require("./QuizHome"));

var _QuizRound = _interopRequireDefault(require("./QuizRound"));

var _QuizRoundOverview = _interopRequireDefault(require("./QuizRoundOverview"));

var _QuizCategories = _interopRequireDefault(require("./QuizCategories"));

var _QuizSubjects = _interopRequireDefault(require("./QuizSubjects"));

var _EquizzerActions = _interopRequireDefault(require("./actions/EquizzerActions"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _OverlaySpinner = _interopRequireDefault(require("../Spinner/OverlaySpinner"));

var _AlertHelper = require("../../../helpers/AlertHelper");

var _QuizStrings = require("./QuizStrings");

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _ErrorHelper = require("../../../helpers/ErrorHelper");

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _HttpRequest = require("../../../utils/HttpRequest");

var _FeatureManager = _interopRequireDefault(require("../../../utils/features/FeatureManager"));

var _DataStoreComponent2 = _interopRequireDefault(require("../DataStoreComponent/DataStoreComponent2"));

var _QuizTournament = _interopRequireWildcard(require("./QuizTournament"));

var _TournamentStateHelper = _interopRequireWildcard(require("../../../helpers/TournamentStateHelper"));

var _ResumeSuspendListeners = require("../../../helpers/ResumeSuspendListeners");

var _StringHelper = _interopRequireDefault(require("../../../helpers/StringHelper"));

var _AppUtils = require("../../../utils/AppUtils");

var _NavigationManagerCordova = _interopRequireDefault(require("../../NavigationManagerCordova"));

var _KesiConstants = require("../../../KESI2/KesiConstants");

var _QuizOfflineHelper = _interopRequireDefault(require("./services/QuizOfflineHelper"));

var _RegisterInstance = _interopRequireDefault(require("../../../KESI2/Services/RegisterInstance"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _QuizPushHelper = _interopRequireDefault(require("./services/QuizPushHelper"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var PAGES = {
  NEW_ROUND: 'new_round',
  HIGHSCORE: 'highscore',
  SETTINGS: 'settings',
  ROUND: 'round',
  OPPONENTS: 'opponents',
  CATEGORIES: 'categories',
  RUNNING: 'running',
  OVERVIEW: 'overview',
  TOURNAMENT: 'tournament',
  LEAGUE: 'liga'
};
var PLAYER_STATES = {
  CHALLENGER: 'challenger',
  OPPONENT: 'opponent'
};
exports.PLAYER_STATES = PLAYER_STATES;

var Quiz = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(Quiz, _DataStoreComponent);

  var _super = _createSuper(Quiz);

  function Quiz(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Quiz);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onWindowSizeChanged", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _TimeoutHelper.timeout)(500);

            case 2:
              _this.forceUpdate();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "changePage", function (nextPage) {
      console.log('changePage', nextPage); // if (this.props.runsInKesi) {

      var stateToSet = {};

      if (nextPage === PAGES.TOURNAMENT || nextPage === PAGES.LEAGUE) {
        throw new Error('switching to tournament or league is not yet implemented in QD for KESI');
      } // set navigation bar back button


      switch (nextPage) {
        case PAGES.RUNNING:
        case PAGES.HIGHSCORE:
        case PAGES.OPPONENTS:
          if (_this.props.runsInKesi) {
            var path = _NavigationManagerCordova["default"].getCurrentPath();

            var pathParts = path.split(_KesiConstants.KESI_PATH_DELIMITER);
            pathParts.pop();
            var urlToGoTo = pathParts.join(_KesiConstants.KESI_PATH_DELIMITER);
            (0, _AppUtils.setGlobalBackButtonFunc)(function () {
              return _NavigationManagerCordova["default"].goTo("".concat(_config["default"].baseRoute, "/").concat(urlToGoTo));
            });
          }

          break;

        default:
          (0, _AppUtils.setGlobalBackButtonFunc)(function () {
            return _this.changePage(PAGES.RUNNING);
          });
      }

      if (nextPage === PAGES.RUNNING || nextPage === PAGES.HIGHSCORE || nextPage === PAGES.OPPONENTS) {
        // if going to home page (and not coming from home page) re-initialize game to get game changes
        var waitingMessages = _QuizPushHelper["default"].getAllWaitingMessages();

        if (waitingMessages.length > 0) {
          var bigMessage = '<div style="text-align:center;">';
          waitingMessages.forEach(function (message) {
            bigMessage += "".concat(message, "<br/><br/>");
          });
          bigMessage += '</div>';
          setTimeout(function () {
            (0, _AlertHelper.showAlertWithOptions)({
              html: bigMessage,
              title: 'Neue Nachrichten',
              centeredContent: true,
              size: 'large'
            });
          }, 0);

          _QuizPushHelper["default"].resetAllMessages();
        }
      }

      stateToSet.page = nextPage;

      _this.setState(stateToSet); //   return
      // }
      // switch (nextPage) {
      //   case PAGES.OVERVIEW:
      //     NavigationManager.goToQuizRoundOverview(this.props.route.tournamentMode)
      //     break
      //
      //   case PAGES.TOURNAMENT:
      //     NavigationManager.goToTournamentStart()
      //     break
      //
      //   case PAGES.RUNNING:
      //   case PAGES.LEAGUE:
      //     NavigationManager.goToQuizHome(this.props.route.tournamentMode)
      //     break
      //
      //   case PAGES.ROUND:
      //     NavigationManager.goToQuizRound(this.props.route.tournamentMode)
      //     break
      //
      //   case PAGES.CATEGORIES:
      //     NavigationManager.goToQuizCategories(this.props.route.tournamentMode)
      //     break
      // }

    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getAuthToken", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this.props.getAuthToken) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", _this.props.getAuthToken());

            case 2:
              if (!_config["default"].useDrupalContent) {
                _context2.next = 8;
                break;
              }

              _context2.t0 = "Bearer ";
              _context2.next = 6;
              return _RegisterInstance["default"].getAccessToken('quizUser:read quizUser:write quizGroup:read quizGame:read quizGame:write');

            case 6:
              _context2.t1 = _context2.sent;
              return _context2.abrupt("return", _context2.t0.concat.call(_context2.t0, _context2.t1));

            case 8:
              return _context2.abrupt("return", _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_AUTH]._auth);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTournamentUpdate", function () {
      var tournament = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT] || {};

      if (tournament) {
        var phase = tournament.phase;

        if (phase === _QuizTournament.TOURNAMENT_PHASES.END) {
          var closeAlert = (0, _AlertHelper.showWideAlertHtmlWithoutButtons)('Das Turnier ist vorbei. Vielen Dank fürs Mitspielen!', 'Turnier beendet', false);
          setTimeout(function () {
            closeAlert();

            if (_this.props.runsInKesi) {
              console.warn('Quiz manages pages automatically but nothing implemented for tournament start.');
              return;
            } // this page will show the confetti screen


            _NavigationManager["default"].goToTournamentStart(); // this.changePage(PAGES.TOURNAMENT)

          }, 3000);
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleMessage", function (data) {
      _this.handlePush(data.detail);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handlePush", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(data) {
        var gameId, auth, game, currentGame, initQuizEvent;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(data && data.actionParams)) {
                  _context3.next = 27;
                  break;
                }

                gameId = JSON.parse(data.actionParams).gameId;
                _context3.next = 4;
                return _this.getAuthToken();

              case 4:
                auth = _context3.sent;

                if (!gameId) {
                  _context3.next = 27;
                  break;
                }

                if (auth) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return");

              case 8:
                _context3.next = 10;
                return _RestService["default"].getGames([gameId], auth);

              case 10:
                game = _context3.sent;
                currentGame = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GAME);
                console.log('handlePush', currentGame, _this.state.page, gameId);

                if (!(data.systemAction === 'updateQuiz' && !(_this.state.page === PAGES.ROUND && gameId === currentGame.id))) {
                  _context3.next = 27;
                  break;
                }

                _context3.next = 16;
                return _EquizzerActions["default"].updateGameInAllGames(game);

              case 16:
                if (!(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].id === gameId)) {
                  _context3.next = 19;
                  break;
                }

                _context3.next = 19;
                return _EquizzerActions["default"].updateGame(game);

              case 19:
                initQuizEvent = new window.CustomEvent('initQuiz');
                document.dispatchEvent(initQuizEvent);

                if (!(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].id === gameId && (_this.props.route.page === PAGES.ROUND || _this.props.route.page === PAGES.CATEGORIES || _this.props.route.page === PAGES.OVERVIEW))) {
                  _context3.next = 23;
                  break;
                }

                return _context3.abrupt("return");

              case 23:
                if (!_this.props.route.tournamentMode) {
                  _context3.next = 26;
                  break;
                }

                console.log("not handling message with data ".concat((0, _stringify["default"])(data), " in tournament mode"));
                return _context3.abrupt("return");

              case 26:
                console.log("handling message with data ".concat((0, _stringify["default"])(data), " not in tournament mode"));

              case 27:
                if (!(data.systemAction === 'liga')) {
                  _context3.next = 33;
                  break;
                }

                if (!_this.props.runsInKesi) {
                  _context3.next = 31;
                  break;
                }

                console.warn('Quiz manages pages automatically but nothing implemented for liga.');
                return _context3.abrupt("return");

              case 31:
                _this.changePage(PAGES.LEAGUE);

                return _context3.abrupt("return");

              case 33:
                console.log('handlePush', data, _this.state.page, _this.state.page !== PAGES.ROUND && _this.state.page !== PAGES.CATEGORIES && _this.state.page !== PAGES.OVERVIEW);

                if (!(_this.state.page !== PAGES.ROUND && _this.state.page !== PAGES.CATEGORIES && _this.state.page !== PAGES.OVERVIEW)) {
                  _context3.next = 40;
                  break;
                }

                _context3.next = 37;
                return (0, _TimeoutHelper.timeout)();

              case 37:
                (0, _AlertHelper.showAlertWithOptions)({
                  html: data.body,
                  title: data.title,
                  centeredContent: true,
                  size: 'large'
                });
                _context3.next = 44;
                break;

              case 40:
                if (!(_this.state.page === PAGES.ROUND || _this.state.page === PAGES.CATEGORIES || _this.state.page === PAGES.OVERVIEW)) {
                  _context3.next = 44;
                  break;
                }

                console.log('handlePush store Message', data);
                _context3.next = 44;
                return _QuizPushHelper["default"].storeMessage(data);

              case 44:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAppResume", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var authToken, historyBasedFeedback;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.t0 = "Bearer ";
              _context4.next = 3;
              return _RegisterInstance["default"].getAccessToken('quizUser:read quizUser:write quizGroup:read quizGame:read quizGame:write');

            case 3:
              _context4.t1 = _context4.sent;
              authToken = _context4.t0.concat.call(_context4.t0, _context4.t1);
              _context4.next = 7;
              return _GameService["default"].loadHistoryBasedFeedback(authToken);

            case 7:
              historyBasedFeedback = _context4.sent;

              _EquizzerActions["default"].setHistoryBasedFeedback(historyBasedFeedback);

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOpenHome", function () {
      _this.changePage(PAGES.RUNNING);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onResumeRound", function (gameData, selectedOpponent) {
      // show category info only if this device's user starts a round
      // if (showCategoryDescription(this.state.learningState, gameData.rounds[gameData.rounds.length - 1].category, false, false, () => this.onResumeRound(gameData, selectedOpponent))) {
      //   return
      // }
      console.log('onResumeRound', gameData);

      var _UserService$getPlaye = _UserService["default"].getPlayerState(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER], selectedOpponent, gameData),
          userData = _UserService$getPlaye.userData,
          selectedOpponentData = _UserService$getPlaye.selectedOpponentData; // update logged in player's game state


      console.log('onResumeRound1', userData);

      _EquizzerActions["default"].setUser(userData, 'onResumeRound');

      if (userData.points) {
        _EquizzerActions["default"].setUserPoints(userData.points);
      } else if (userData.subjects) {
        var subjectId = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_SUBJECT_ID);

        var subject = userData.subjects.find(function (subject) {
          return subject.emsId === subjectId;
        });

        if (subject) {
          _EquizzerActions["default"].setUserPoints(subject.points);
        }
      }

      _EquizzerActions["default"].setOpponent(selectedOpponentData);

      _this.changePage(PAGES.ROUND);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onStartRound", /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(game) {
        var category,
            invokeCount,
            response,
            userAuth,
            updateOpponents,
            _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                category = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : '';
                invokeCount = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : 0;
                _context5.next = 4;
                return _EquizzerActions["default"].updateGame({});

              case 4:
                _context5.prev = 4;
                // const status = GameService.getNetworkStatus()
                // if (status.toLowerCase() !== 'none') {
                response = null;
                _context5.next = 8;
                return _this.getAuthToken();

              case 8:
                userAuth = _context5.sent;
                _context5.prev = 9;

                if (game.rounds) {
                  _context5.next = 16;
                  break;
                }

                _context5.next = 13;
                return _GameService["default"].postCurrentGame(game, userAuth);

              case 13:
                response = _context5.sent;
                _context5.next = 25;
                break;

              case 16:
                if (!(category === '')) {
                  _context5.next = 22;
                  break;
                }

                _context5.next = 19;
                return _GameService["default"].loadCurrentGame(game.emsId, userAuth);

              case 19:
                response = _context5.sent;
                _context5.next = 25;
                break;

              case 22:
                _context5.next = 24;
                return _GameService["default"].getQuestionSet(game, category, userAuth);

              case 24:
                response = _context5.sent;

              case 25:
                console.log('response onStartRound', response);
                _context5.next = 36;
                break;

              case 28:
                _context5.prev = 28;
                _context5.t0 = _context5["catch"](9);
                (0, _AlertHelper.showAlertWithOptions)({
                  html: (0, _ErrorHelper.getErrorMessage)(_context5.t0),
                  title: (0, _QuizStrings.getString)('FAILURE'),
                  centeredContent: true
                }); // showWideAlertHtml(getErrorMessage(error), getString('FAILURE'), true)

                console.log('ERROR: Quiz, onStartRound, no modified game', game);

                _this.showSpinner(false);

                _this.setState({
                  initialized: true
                });

                _this.changePage(PAGES.RUNNING);

                return _context5.abrupt("return", _promise["default"].resolve());

              case 36:
                if (!response) {
                  _context5.next = 43;
                  break;
                }

                _context5.next = 39;
                return _EquizzerActions["default"].updateGameInAllGames(response);

              case 39:
                _context5.next = 41;
                return _EquizzerActions["default"].updateGame(response);

              case 41:
                // update the opponents list
                updateOpponents = _UserService["default"].updateOpponentsList(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_OPPONENTS], response.opponent, response.emsId);

                _EquizzerActions["default"].setOpponentsList(updateOpponents);

              case 43:
                _this.showSpinner(false);

                _this.changePage(PAGES.ROUND);

                _context5.next = 52;
                break;

              case 47:
                _context5.prev = 47;
                _context5.t1 = _context5["catch"](4);
                console.log('ERROR: Quiz, onStartRound', _context5.t1);

                _this.changePage(PAGES.ROUND);

                return _context5.abrupt("return", _promise["default"].reject(_context5.t1));

              case 52:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[4, 47], [9, 28]]);
      }));

      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDisplayCategories", /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(game) {
        var isOverview,
            categories,
            userAuth,
            response,
            gameData,
            otherPlayerStartedGame,
            updateOpponents,
            yesButton,
            noButton,
            okButton,
            _args6 = arguments;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                isOverview = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : false;
                console.log('onDisplayCategories', game);

                if (!_this.checkIfCanStartRound(game)) {
                  _context6.next = 51;
                  break;
                }

                _context6.next = 5;
                return _EquizzerActions["default"].setCategoriesList([]);

              case 5:
                if (!isOverview) {
                  _context6.next = 14;
                  break;
                }

                categories = _GameService["default"].prepareCategoriesList(game);
                _context6.next = 9;
                return _EquizzerActions["default"].updateGame(game);

              case 9:
                _context6.next = 11;
                return _EquizzerActions["default"].setCategoriesList(categories);

              case 11:
                _this.showSpinner(false);

                _context6.next = 49;
                break;

              case 14:
                _context6.prev = 14;
                _context6.next = 17;
                return _this.getAuthToken();

              case 17:
                userAuth = _context6.sent;
                _context6.next = 20;
                return _GameService["default"].getGameCategories(game, userAuth);

              case 20:
                response = _context6.sent;
                _context6.next = 23;
                return _EquizzerActions["default"].setCategoriesList(response.categories);

              case 23:
                gameData = response.gameData;
                _context6.next = 26;
                return _EquizzerActions["default"].updateGame(gameData);

              case 26:
                // update the opponents list
                otherPlayerStartedGame = gameData.rounds && gameData.rounds.length > 0 && gameData.rounds[0].actionState !== 'chooseCategory';
                console.log('onDisplayCategories', otherPlayerStartedGame, gameData);
                updateOpponents = _UserService["default"].updateOpponentsList(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_OPPONENTS], otherPlayerStartedGame ? gameData.challenger : gameData.opponent, gameData.emsId);

                _EquizzerActions["default"].setOpponentsList(updateOpponents);

                _this.showSpinner(false);

                if (!otherPlayerStartedGame) {
                  _context6.next = 34;
                  break;
                }

                console.log('other player started game');
                return _context6.abrupt("return", true);

              case 34:
                _context6.next = 49;
                break;

              case 36:
                _context6.prev = 36;
                _context6.t0 = _context6["catch"](14);
                yesButton = {
                  label: (0, _QuizStrings.getString)('YES'),
                  callback: function callback() {
                    _this.onDisplayCategories(game, isOverview, true);
                  }
                };
                noButton = {
                  label: (0, _QuizStrings.getString)('NO'),
                  callback: function callback() {
                    _this.changePage(PAGES.RUNNING);
                  }
                };
                okButton = {
                  label: (0, _QuizStrings.getString)('OK'),
                  callback: function callback() {
                    _this.changePage(PAGES.RUNNING);
                  }
                };

                if (!(_context6.t0 === 'always running game present')) {
                  _context6.next = 45;
                  break;
                }

                _this.showSpinner(false);

                (0, _AlertHelper.showAlertWithOptions)({
                  html: (0, _ErrorHelper.getErrorMessage)(_context6.t0),
                  title: (0, _QuizStrings.getString)('FAILURE'),
                  centeredContent: true,
                  showCloseButton: false,
                  buttons: [okButton]
                }); // showWideAlertHtml(getErrorMessage(error), getString('FAILURE'), false, [okButton])

                return _context6.abrupt("return", false);

              case 45:
                _this.showSpinner(false);

                console.error('ERROR: Quiz, onDisplayCategories', _context6.t0, (0, _ErrorHelper.getErrorMessage)(_context6.t0));
                (0, _AlertHelper.showAlertWithOptions)({
                  html: (0, _ErrorHelper.getErrorMessage)(_context6.t0, true),
                  title: (0, _QuizStrings.getString)('FAILURE'),
                  centeredContent: true,
                  showCloseButton: false,
                  buttons: [noButton, yesButton]
                }); // showWideAlertHtml(getErrorMessage(error, true), getString('FAILURE'), false, [noButton, yesButton])

                return _context6.abrupt("return", false);

              case 49:
                _this.changePage(PAGES.CATEGORIES);

                return _context6.abrupt("return", false);

              case 51:
                return _context6.abrupt("return", false);

              case 52:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[14, 36]]);
      }));

      return function (_x3) {
        return _ref6.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onQuizRoundOverview", /*#__PURE__*/function () {
      var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(currentGame) {
        var gameComplete,
            invokeCount,
            userAuth,
            response,
            errorString,
            roundsPlayed,
            message,
            selectedOpponent,
            playedOpponents,
            _args7 = arguments;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                gameComplete = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : false;
                invokeCount = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : 0;

                _this.setState({
                  initialized: false
                });

                _context7.next = 5;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_CATEGORIES, [], false);

              case 5:
                if (gameComplete) {
                  _context7.next = 59;
                  break;
                }

                _context7.prev = 6;
                _context7.next = 9;
                return _this.getAuthToken();

              case 9:
                userAuth = _context7.sent;
                response = null;
                _context7.prev = 11;
                _context7.next = 14;
                return _GameService["default"].postCurrentGame(currentGame, userAuth);

              case 14:
                response = _context7.sent;
                _context7.next = 36;
                break;

              case 17:
                _context7.prev = 17;
                _context7.t0 = _context7["catch"](11);
                (0, _AlertHelper.showAlertWithOptions)({
                  html: (0, _ErrorHelper.getErrorMessage)(_context7.t0),
                  title: (0, _QuizStrings.getString)('FAILURE'),
                  centeredContent: true
                }); // showWideAlertHtml(getErrorMessage(error), getString('FAILURE'), true)

                errorString = _context7.t0.message ? _context7.t0.message : _context7.t0;

                if (errorString.startsWith(_HttpRequest.HTTP_ERROR_PREFIX)) {
                  _context7.next = 33;
                  break;
                }

                currentGame.isDirty = true;
                console.log('ERROR: Quiz, onQuizRoundOverview', currentGame);
                _context7.next = 26;
                return _EquizzerActions["default"].updateGameInAllGames(currentGame);

              case 26:
                _context7.next = 28;
                return _EquizzerActions["default"].updateGame(currentGame);

              case 28:
                _this.setState({
                  initialized: true
                });

                _this.changePage(PAGES.OVERVIEW);

                return _context7.abrupt("return", _promise["default"].resolve());

              case 33:
                _this.setState({
                  initialized: true
                });

                _this.changePage(PAGES.RUNNING);

                return _context7.abrupt("return", _promise["default"].resolve());

              case 36:
                _context7.next = 38;
                return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.QD_ROUND_COUNT);

              case 38:
                roundsPlayed = _context7.sent;

                if (roundsPlayed) {
                  roundsPlayed += 1;
                } else {
                  roundsPlayed = 1;
                }

                message = {
                  value: roundsPlayed,
                  path: _DataStore.DATA_STORE_PATHS.QD_ROUND_COUNT
                }; // sendMessageToGroup('setData', JSON.stringify(message))

                console.log('SUCCESS: Quiz, onQuizRoundOverview', response);
                _context7.next = 44;
                return _EquizzerActions["default"].updateGameInAllGames(response);

              case 44:
                _context7.next = 46;
                return _EquizzerActions["default"].updateGame(response);

              case 46:
                _this.changePage(PAGES.OVERVIEW);

                _this.setState({
                  initialized: true
                });

                return _context7.abrupt("return", _promise["default"].resolve());

              case 51:
                _context7.prev = 51;
                _context7.t1 = _context7["catch"](6);

                _this.setState({
                  initialized: true
                });

                console.log('ERROR: Quiz, onQuizRoundOverview', _context7.t1);

                _this.changePage(PAGES.OVERVIEW);

                return _context7.abrupt("return", _promise["default"].reject(_context7.t1));

              case 57:
                _context7.next = 63;
                break;

              case 59:
                _this.setState({
                  initialized: true
                });

                _this.changePage(PAGES.OVERVIEW);

                if (_this.props.route.tournamentMode) {
                  selectedOpponent = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT];
                  playedOpponents = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_TOURNAMENT_OPPONENTS_PLAYED] || {};
                  console.log('PLAYED OPPONENTS SAVING: ', selectedOpponent, playedOpponents);

                  if (selectedOpponent && playedOpponents) {
                    if (!playedOpponents[selectedOpponent.id]) {
                      playedOpponents[selectedOpponent.id] = [currentGame.id];
                    } else {
                      if (playedOpponents[selectedOpponent.id].indexOf(currentGame.id) < 0) {
                        playedOpponents[selectedOpponent.id].push(currentGame.id);
                      }
                    }

                    console.log('PLAYED OPPONENTS SAVING: ', playedOpponents); // has to be permanent because user might shutdown phone and we can not recover this data

                    _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_TOURNAMENT_OPPONENTS_PLAYED, playedOpponents);
                  }
                }

                return _context7.abrupt("return", _promise["default"].resolve('completed game'));

              case 63:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[6, 51], [11, 17]]);
      }));

      return function (_x4) {
        return _ref7.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setOpponent", /*#__PURE__*/function () {
      var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(opponent) {
        var okButton, status, alreadyStarted, retryButton;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                console.log('setOpponent', opponent);
                okButton = {
                  label: (0, _QuizStrings.getString)('OK'),
                  callback: function callback() {}
                };

                _this.showSpinner(true);

                status = _GameService["default"].getNetworkStatus();

                if (!(status.toLowerCase() !== 'none')) {
                  _context8.next = 23;
                  break;
                }

                _context8.next = 7;
                return _EquizzerActions["default"].setOpponent(opponent);

              case 7:
                _context8.prev = 7;
                _context8.next = 10;
                return _this.onDisplayCategories({
                  challenger: _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id,
                  opponent: opponent.id
                }, false, opponent);

              case 10:
                alreadyStarted = _context8.sent;

                if (!alreadyStarted) {
                  _context8.next = 15;
                  break;
                }

                _context8.next = 14;
                return (0, _TimeoutHelper.timeout)(300);

              case 14:
                _this.onResumeRound(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME], opponent);

              case 15:
                _this.showSpinner(false);

                _context8.next = 21;
                break;

              case 18:
                _context8.prev = 18;
                _context8.t0 = _context8["catch"](7);

                _this.showSpinner(false);

              case 21:
                _context8.next = 26;
                break;

              case 23:
                _this.showSpinner(false);

                retryButton = {
                  label: (0, _QuizStrings.getString)('TRY_AGAIN'),
                  callback: function callback() {
                    _this.showSpinner(true);

                    _this.setOpponent(opponent);
                  }
                };
                (0, _AlertHelper.showAlertWithOptions)({
                  html: (0, _QuizStrings.getString)('NETWORK_LOST'),
                  title: (0, _QuizStrings.getString)('OOPS'),
                  centeredContent: true,
                  buttons: [okButton, retryButton]
                }); // showWideAlertHtml(getString('NETWORK_LOST'), getString('OOPS'), true, [okButton, retryButton])

              case 26:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[7, 18]]);
      }));

      return function (_x5) {
        return _ref8.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showSpinner", function (show) {
      _this.setState({
        showSpinner: show
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onGoBack", function () {
      _this.changePage(PAGES.RUNNING);
    });
    _this.___id = _StringHelper["default"].createShortId();
    _this.state = {
      initialized: false,
      page: props.runsInKesi ? props.startPageInKesi : props.route.page,
      waitingGames: false,
      showSpinner: false
    };

    _this.setDataStorePaths([_DataStore.DATA_STORE_PATHS.QD_USER_IMAGE_PATH, _DataStore.DATA_STORE_PATHS.QD_ALL_GAME, _DataStore.DATA_STORE_PATHS.QD_GAME, _DataStore.DATA_STORE_PATHS.QD_USER, _DataStore.DATA_STORE_PATHS.QD_OPPONENTS, _DataStore.DATA_STORE_PATHS.QD_CATEGORIES, _DataStore.DATA_STORE_PATHS.QD_NETWORK_STATUS, _DataStore.DATA_STORE_PATHS.QD_USER_AUTH, _DataStore.DATA_STORE_PATHS.QD_USER_AUTH_AUTH, _DataStore.DATA_STORE_PATHS.QD_GROUP_USERS, _DataStore.DATA_STORE_PATHS.QD_LEARNING_STATE, _DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT, _DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT_ID, _DataStore.DATA_STORE_PATHS.QD_TOURNAMENT_OPPONENTS_PLAYED, _DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT, _DataStore.DATA_STORE_PATHS.QD_MESSAGES]); // this.stores = [ThemeStore]


    return _this;
  }

  (0, _createClass2["default"])(Quiz, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.initQuiz();
      }, 0);

      if (this.props.route.tournamentMode) {
        _TournamentStateHelper["default"].addTournamentListener(_TournamentStateHelper.TOURNAMENT_COMMANDS.MY_TOURNAMENT_UPDATE, this.handleTournamentUpdate);
      }

      document.addEventListener('quizPushAlert', this.handleMessage);
      (0, _ResumeSuspendListeners.addOnResumeListener)(this.onAppResume);

      if (!_DeviceInfoHelper["default"].isBrowser()) {
        window.screen.orientation.addEventListener('change', this.onWindowSizeChanged.bind(this));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('quizPushAlert', this.handleMessage);
      (0, _ResumeSuspendListeners.removeOnResumeListener)(this.onAppResume);

      if (this.props.route.tournamentMode) {
        _TournamentStateHelper["default"].removeTournamentListener(_TournamentStateHelper.TOURNAMENT_COMMANDS.MY_TOURNAMENT_UPDATE, this.handleTournamentUpdate);
      }

      if (!_DeviceInfoHelper["default"].isBrowser()) {
        window.screen.orientation.removeEventListener('change', this.onWindowSizeChanged.bind(this));
      }

      (0, _get2["default"])((0, _getPrototypeOf2["default"])(Quiz.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "goHome",
    value: function goHome() {
      if (this.props.runsInKesi) {
        _NavigationManager["default"].goBack();

        return;
      }

      _NavigationManager["default"].goHome(this.props.route.tournamentMode);
    }
  }, {
    key: "checkIfCanStartRound",
    value: function checkIfCanStartRound(game) {
      if (this.props.route.tournamentMode) {
        var currentTournament = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT);

        console.log('current tournament', currentTournament.phase, currentTournament);
        var canStart = currentTournament.phase === _QuizTournament.TOURNAMENT_PHASES.PLAY_GAMES || currentTournament.phase === _QuizTournament.TOURNAMENT_PHASES.WAIT_FOR_END && game.rounds && game.rounds.length > 0;

        if (!canStart) {
          (0, _AlertHelper.showWideAlertHtml)((0, _QuizStrings.getString)('QD_TOURNAMENT_CANT_START_NEW_GAMES'), (0, _QuizStrings.getString)('PLEASE_NOTE'), false);
        }

        return canStart;
      }

      return true;
    }
  }, {
    key: "initQuiz",
    value: function () {
      var _initQuiz = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
        var _this3 = this;

        var feature, userAuth, newUser, groupUsers, storedImages, groupUsersWithImage, loadedUser, opponents, allGamesUnfiltered, allGame, historyBasedFeedback, completedGameIds, expiredGameIds;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (this.state.initialized) {
                  this.setState({
                    initialized: false
                  });
                }

                _context9.prev = 1;

                if (!_config["default"].useDrupalContent) {
                  _context9.next = 13;
                  break;
                }

                _context9.t0 = "Bearer ";
                _context9.next = 6;
                return _RegisterInstance["default"].getAccessToken('quizUser:read quizUser:write quizGroup:read quizGame:read quizGame:write');

              case 6:
                _context9.t1 = _context9.sent;
                userAuth = _context9.t0.concat.call(_context9.t0, _context9.t1);
                _context9.next = 10;
                return _FeatureManager["default"].getFeatureWaitingForStore(_config["default"].requiredFeature);

              case 10:
                feature = _context9.sent;
                _context9.next = 26;
                break;

              case 13:
                if (!this.props.getAuthToken) {
                  _context9.next = 20;
                  break;
                }

                userAuth = this.props.getAuthToken();
                _context9.next = 17;
                return _FeatureManager["default"].getFeatureWaitingForStore(_config["default"].requiredFeature);

              case 17:
                feature = _context9.sent;
                _context9.next = 26;
                break;

              case 20:
                _context9.next = 22;
                return _FeatureManager["default"].getFeatureWaitingForStore(_config["default"].requiredFeature);

              case 22:
                feature = _context9.sent;

                if (!(!feature || !feature.userId || !feature.additionalData || !feature.additionalData._auth)) {
                  _context9.next = 25;
                  break;
                }

                throw new Error('NO_FEATURE_DONT_SHOW');

              case 25:
                userAuth = feature.additionalData ? feature.additionalData._auth : null;

              case 26:
                console.log('feature initQuiz', feature);
                _context9.next = 29;
                return _UserService["default"].loadLearningStates(userAuth);

              case 29:
                console.log('AAA initQuiz', userAuth, feature.userId);
                _context9.next = 32;
                return _UserService["default"].preload(feature.userId, userAuth);

              case 32:
                newUser = _context9.sent;
                // // set user application state
                console.log('set user initQuiz quiz.js', newUser);

                if (!newUser.playgroupId) {
                  _context9.next = 69;
                  break;
                }

                _context9.next = 37;
                return _EquizzerActions["default"].setGroupId(newUser.playgroupId);

              case 37:
                _context9.next = 39;
                return _UserService["default"].getAllUsersAndLoadTheme(newUser.playgroupId, userAuth);

              case 39:
                groupUsers = _context9.sent;
                storedImages = this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_IMAGE_PATH];
                _context9.next = 43;
                return _UserService["default"].getUserImages(groupUsers, this.state.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_USERS], userAuth, storedImages);

              case 43:
                groupUsersWithImage = _context9.sent;

                // // set groupUsers application state
                _EquizzerActions["default"].setGroupUsers(groupUsersWithImage);

                loadedUser = newUser; // // filter logged in user from groupUsers list
                // // and get list of opponents

                opponents = [];
                groupUsersWithImage.forEach(function (groupUser) {
                  if (loadedUser && groupUser && groupUser.id === loadedUser.id) {
                    loadedUser.picture = groupUser.picture; // set user application state

                    _EquizzerActions["default"].setUser(loadedUser, 'initQuiz');

                    _EquizzerActions["default"].setUserPoints(groupUser.points); // return

                  } else {
                    opponents.push(groupUser);
                  }
                }); // set opponentslist application state

                _EquizzerActions["default"].setOpponentsList(opponents);

                _context9.next = 51;
                return _GameService["default"].loadAllGame(userAuth);

              case 51:
                allGamesUnfiltered = _context9.sent;
                _context9.next = 54;
                return _GameService["default"].loadLastGameWithEachOpponent(loadedUser, allGamesUnfiltered);

              case 54:
                allGame = _context9.sent;
                _context9.next = 57;
                return _EquizzerActions["default"].setAllGame(allGame);

              case 57:
                _context9.next = 59;
                return _GameService["default"].loadHistoryBasedFeedback(userAuth);

              case 59:
                historyBasedFeedback = _context9.sent;

                _EquizzerActions["default"].setHistoryBasedFeedback(historyBasedFeedback); // get completed game ids


                completedGameIds = _GameService["default"].getCompletedGameIds(allGame); // set completed game ids application state

                _EquizzerActions["default"].updateCompletedGameIds(completedGameIds);

                _context9.next = 65;
                return _GameService["default"].getAllExpiredGames(allGamesUnfiltered);

              case 65:
                expiredGameIds = _context9.sent;

                _EquizzerActions["default"].updateExpiredGameIds(expiredGameIds);

                _context9.next = 74;
                break;

              case 69:
                _context9.next = 71;
                return _EquizzerActions["default"].setUser(newUser, 'initQuiz2');

              case 71:
                if (!newUser.points) {
                  _context9.next = 74;
                  break;
                }

                _context9.next = 74;
                return _EquizzerActions["default"].setUserPoints(newUser.points);

              case 74:
                _TournamentStateHelper["default"].instance();

                _context9.next = 77;
                return _TournamentStateHelper["default"].setupInitialState();

              case 77:
                // // await GameService.sendDirtyData()
                // // on success, hide the spinner and render the QuizHome component
                setTimeout(function () {
                  _this3.setState({
                    initialized: true
                  });
                }, 0);
                _context9.next = 85;
                break;

              case 80:
                _context9.prev = 80;
                _context9.t2 = _context9["catch"](1);
                console.log(_context9.t2);

                if (_context9.t2.message !== 'NO_FEATURE_DONT_SHOW') {
                  (0, _AlertHelper.showAlertWithOptions)({
                    html: (0, _ErrorHelper.getErrorMessage)(_context9.t2),
                    title: (0, _QuizStrings.getString)('FAILURE'),
                    centeredContent: true
                  }); // showWideAlertHtml(getErrorMessage(error), getString('FAILURE'))
                }

                setTimeout(function () {
                  _this3.goHome();
                }, 0);

              case 85:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[1, 80]]);
      }));

      function initQuiz() {
        return _initQuiz.apply(this, arguments);
      }

      return initQuiz;
    }()
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      console.log('render Loading in Quiz');
      return /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      if (!this.state.initialized) {
        return this.renderLoading();
      }

      var element = null;

      if (this.state.page === 'round') {
        element = /*#__PURE__*/_react["default"].createElement(_QuizRound["default"], {
          setTitle: this.props.setTitle,
          onRoundComplete: this.onQuizRoundOverview,
          onReload: this.onStartRound,
          sidebarDocked: this.props.sidebarDocked,
          tournamentMode: this.props.route.tournamentMode,
          isInKesi: this.props.runsInKesi
        });
      } else if (this.state.page === PAGES.OVERVIEW) {
        element = /*#__PURE__*/_react["default"].createElement(_QuizRoundOverview["default"], {
          setTitle: this.props.setTitle,
          onChooseCategory: this.onDisplayCategories,
          onNextRound: this.onResumeRound,
          onSetOpponent: this.setOpponent,
          onGoHome: this.onOpenHome,
          onStartRound: this.onStartRound,
          onBack: this.onGoBack,
          showBackButton: !this.props.runsInKesi,
          runsInKesi: this.props.runsInKesi,
          tournamentMode: this.props.route.tournamentMode,
          getAuthToken: this.getAuthToken,
          onRoundComplete: this.onQuizRoundOverview
        });
      } else if (this.state.page === 'categories') {
        element = /*#__PURE__*/_react["default"].createElement(_QuizCategories["default"], {
          setTitle: this.props.setTitle,
          onStartRound: this.onStartRound,
          onBack: this.onGoBack,
          showSpinner: this.showSpinner,
          tournamentMode: this.props.route.tournamentMode,
          getAuthToken: this.getAuthToken,
          runsInKesi: this.props.runsInKesi
        });
      } else if (this.state.page === 'subjects') {
        element = /*#__PURE__*/_react["default"].createElement(_QuizSubjects["default"], {
          setTitle: this.props.setTitle,
          onBack: this.onGoBack,
          showSpinner: this.showSpinner,
          tournamentMode: this.props.route.tournamentMode,
          getAuthToken: this.getAuthToken,
          runsInKesi: this.props.runsInKesi,
          changePageToQuizHome: function changePageToQuizHome() {
            return _this4.changePage(PAGES.RUNNING);
          },
          setAblyAsRegistered: this.props.setAblyAsRegistered
        });
      } else {
        element = /*#__PURE__*/_react["default"].createElement(_QuizHome["default"], {
          setTitle: this.props.setTitle,
          onStartRound: this.onStartRound,
          onFinishedGame: this.onQuizRoundOverview,
          currentPage: this.props.route.page,
          showSpinner: this.showSpinner,
          onBack: this.onGoBack,
          onOpenHome: this.onOpenHome,
          onSetOpponent: this.setOpponent,
          sidebarDocked: this.props.sidebarDocked,
          tournamentMode: this.props.route.tournamentMode,
          onChooseCategory: this.onDisplayCategories,
          onNextRound: this.onResumeRound,
          getAuthToken: this.getAuthToken,
          isInKesi: this.props.runsInKesi,
          changePage: this.changePage
        });
      }

      if (this.state.showSpinner) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            height: '100%'
          }
        }, element, /*#__PURE__*/_react["default"].createElement(_OverlaySpinner["default"], null));
      }

      return element;
    }
  }], [{
    key: "getDerivedStateFromProps",

    /*
    If you need to call classMethods when props change, use componentDidUpdate.
    Update state based on changed props with getDerivedStateFromProps, call classMethods based on updated state in componentDidUpdate
     */
    value: function getDerivedStateFromProps(props, state) {
      if (!props.startPageInKesi && state.page !== props.route.page) {
        var updateObj = {}; // console.log(`Quiz component received new page via props ${props.route.page}`)

        if (props.route.page === 'round') {
          updateObj.initialized = true;
        } // if going to home page (and not coming from home page) re-initialize game to get game changes


        if (!props.route.page) {
          var waitingMessages = _QuizPushHelper["default"].getAllWaitingMessages();

          if (waitingMessages.length > 0) {
            var bigMessage = '<div style="text-align:center;">';
            waitingMessages.forEach(function (message) {
              bigMessage += "".concat(message, "<br/><br/>");
            });
            bigMessage += '</div>'; // const okButton = {
            //   label: getString('OK'),
            // }

            setTimeout(function () {
              (0, _AlertHelper.showAlertWithOptions)({
                html: bigMessage,
                title: 'Neue Nachrichten',
                centeredContent: true
              }); // showWideAlertHtml(bigMessage, 'Neue Nachrichten', true, [okButton])
            }, 0);

            _QuizPushHelper["default"].resetAllMessages();
          }
        }

        updateObj.page = props.route.page;
        return updateObj;
      }

      return null;
    }
  }]);
  return Quiz;
}(_DataStoreComponent2["default"]);

Quiz.propTypes = {
  params: _propTypes["default"].shape({
    id: _propTypes["default"].string
  }),
  route: _propTypes["default"].shape({
    page: _propTypes["default"].string,
    tournamentMode: _propTypes["default"].bool
  }),
  runsInKesi: _propTypes["default"].bool,
  // for KESI apps
  startPageInKesi: _propTypes["default"].string,
  // for KESI apps; if managePagesAutomatically is set to true
  setTitle: _propTypes["default"].func,
  setTitleForChapter: _propTypes["default"].func,
  updateValue: _propTypes["default"].number,
  lockedDevice: _propTypes["default"].bool,
  sidebarDocked: _propTypes["default"].bool,
  getAuthToken: _propTypes["default"].func,
  goUpFunc: _propTypes["default"].func,
  setAblyAsRegistered: _propTypes["default"].func
};
Quiz.defaultProps = {
  // defaults for QD in KESI
  route: {
    page: null,
    tournamentMode: false
  },
  startPageInKesi: PAGES.RUNNING,
  // default for standalone QD
  runsInKesi: false
};
var _default = Quiz;
exports["default"] = _default;